import { useEffect } from 'react';

import { appEventBus } from '@gasbi/shared/web/utils/appEventBus';
import { AppEvents } from '@gasbi/shared/web/utils/appEventBus/eventMap';

import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';

const NotFound = () => {
  useEffect(() => {
    appEventBus.emit(AppEvents.LoadingStateEvent, false);
  }, []);

  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Typography level='title-lg' fontSize='60px'>
        404
      </Typography>
      <Typography level='body-md'>Здається ви десь заблукали</Typography>
    </Stack>
  );
};

export default NotFound;
